/* ----- Palette ----- */

// Grays
export const gray80 = '#616161';
export const gray70 = '#757575';
export const gray60 = '#9E9E9E';
export const gray50 = '#BDBDBD';
export const gray40 = '#E0E0E0';
export const gray30 = '#EEEEEE';
export const gray20 = '#F5F5F5';

export const blueGray = '#5972A3';
export const bluePurple = '#DCE4F3';
export const blue = '#5FB7FF';
export const lightGrey = '#F1F4FA';

// chart colors
export const lightGreen = '#82ca9d';
export const darkGreen = '#17ad50';
export const darkRed = '#d85044';
export const lightRed = '#f49484';

export const CHART_COLORS = {
  bullish: { light: lightGreen, dark: darkGreen },
  bearish: { light: lightRed, dark: darkRed },
};
